import Component from "vue-class-component";
import Vue from "Vue";
import { Prop } from "vue-property-decorator";
import { Color } from "../../models/color";

@Component
export default class Button extends Vue {
	@Prop({ default: "" })
	public icon;

	@Prop({ default: "" })
	public text;

	@Prop({ default: "" })
	public title;

	@Prop({ default: false })
	private disabled;

	@Prop({ default: true })
	private show;

	@Prop({ default: "" })
	public color;

	@Prop({ default: 500 })
	public intensity;

	@Prop({ default: false })
	public isSubmit;

	@Prop({ default: false })
	public outline;

	@Prop({ default: false })
	public circle;

	@Prop({ default: false })
	public textSmall;

	@Prop({ default: false })
	public textUnderline;

	public click(e): void {
		this.$emit("click");
	}

	public isRedColor(): boolean {
		return (this.color === Color[Color.Red].toLowerCase());
	}

	public isGreenColor(): boolean {
		return (this.color === Color[Color.Green].toLowerCase());
	}

	public isBlueColor(): boolean {
		return (this.color === Color[Color.Blue].toLowerCase());
	}

	public isOrangeColor(): boolean {
		return (this.color === Color[Color.Orange].toLowerCase());
	}

	public isGreyColor(): boolean {
		return (this.color === Color[Color.Grey].toLowerCase());
	}

	public isTealColor(): boolean {
		return (this.color === Color[Color.Teal].toLowerCase());
	}

	public isTransparentAndGreenColor(): boolean {
		return (this.color.toLowerCase() === Color[Color.TransparentAndGreen].toLowerCase());
	}

	public isTransparentAndBlueColor(): boolean {
		return (this.color.toLowerCase() === Color[Color.TransparentAndBlue].toLowerCase());
	}

	public isTransparentAndRedColor(): boolean {
		return (this.color.toLowerCase() === Color[Color.TransparentAndRed].toLowerCase());
	}

	public isTransparentAndGreyColor(): boolean {
		return (this.color.toLowerCase() === Color[Color.TransparentAndGrey].toLowerCase());
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/Button/Button.ts